"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class LogApi extends runtime.BaseAPI {
    /**
     * Restituisce i log generati dal batch di certificazione contatti (Auth roles: Admin)
     */
    apiLogLogCertificazioneInfocenterPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Log/log-certificazione-infocenter`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RicercaLogDtoToJSON(requestParameters.ricercaLogDto),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.LogCertificazioneInfoCenterDtoPagedListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce i log generati dal batch di certificazione contatti (Auth roles: Admin)
     */
    apiLogLogCertificazioneInfocenterPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLogLogCertificazioneInfocenterPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Restituisce i log generati dal batch di importazione contatti (Auth roles: Admin)
     */
    apiLogLogTracciatoInfocenterPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Log/log-tracciato-infocenter`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RicercaLogDtoToJSON(requestParameters.ricercaLogDto),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.LogTracciatoInfoCenterDtoPagedListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce i log generati dal batch di importazione contatti (Auth roles: Admin)
     */
    apiLogLogTracciatoInfocenterPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiLogLogTracciatoInfocenterPostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.LogApi = LogApi;
